export default "__VITE_ASSET__493bcc73__"